<template>
  <EmptyState
    class="grow"
    :title="t('components.empty_states.categories.title', { query })"
    :description="t('components.empty_states.categories.description')"
  />
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { EmptyState } from "@/Components/DataTable";

defineProps({
  query: { type: String, required: true },
});

const { t } = useI18n();
</script>
